




































































import Vue from "vue";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export default Vue.extend({
  name: "HowToTakePicture",
  components: {
  },
  data() {
    return {
      TRANSLATION_KEY: "steps.HowToTakePicture",
    };
  },
  props: {
    isPopup: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    setTimeout(() => {
      const swiper = new Swiper((this.$refs as any).swiper, {
        slidesPerView: 2.2,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
        },
      });
    }, 0);
  },
  methods: {
    handleHowToTakePictureInfo() {
      this.$store.state.isLocked = "active";
      setTimeout(() => {
        this.$store.state.isLocked = "";
        // Emit a custom event with the value to be passed
        this.$emit("childEvent");
      }, 1000);
    },

    handleClosePopup() {
      this.$store.state.showInstructionPopup = false;
      window.scrollTo(0, 0);
    },
  },
});
